import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  subscriptionData: [],
  totalsubscription: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
}

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setsubscriptionData(state, { payload }) {
      state.subscriptionData = payload
    },
    updatesubscriptionData(state, { payload }) {
      const objIndex = state.subscriptionData.findIndex((obj) => obj.id === payload.id);
      if (objIndex >= 0) {
        state.subscriptionData[objIndex] = payload
      }
    },
    pushsubscriptionData(state, { payload }) {
      state.subscriptionData.push(payload)
    },
    slicesubscriptionData(state, { payload }) {
      const objIndex = state.subscriptionData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.subscriptionData.splice(objIndex, 1)
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setsubscriptionData, updatesubscriptionData, pushsubscriptionData, slicesubscriptionData, isOpenModal, ModalToggle } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;

export function getsubscription(limit, offset, status, keyword) {
  return async function getsubscriptionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getsubscription(limit, offset, status, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setsubscriptionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function addsubscription(payload) {
  return async function addsubscriptionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addsubscription(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushsubscriptionData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatesubscription(id, data) {
  return async function updatesubscriptionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatesubscription(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatesubscriptionData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deletesubscription(id) {
  return async function deletesubscriptionThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deletesubscription(id).then(
        (response) => {
          dispatch(slicesubscriptionData(id))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
